import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
//@ts-ignore
import LKButton from 'shared/LKButton'
import LKModal, { actions as LKModalActions } from '../../shared/LKModal'

const DeleteConfirmationTrigger: FC<{
  onConfirm: () => void
  disabled: boolean
  alias: string
}> = ({ onConfirm, disabled, alias }) => {
  const dispatch = useDispatch()

  return (
    <>
      <LKButton
        alias={alias}
        disabled={disabled}
        onClick={() => dispatch(LKModalActions.openConfirmation('deleteCommentConfirmation'))}
        name="deleteCommentConfirmation"
      />
      {/* @ts-ignore */}
      <LKModal.Confirmation name="deleteCommentConfirmation" onConfirm={onConfirm} />
    </>
  )
}

export default DeleteConfirmationTrigger
